import { renderErrorMessage, renderSuccessMessage } from "../assets/functions";
import axios from "axios";
import Cookies from "js-cookie";

const api = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? `${process.env.REACT_APP_LOCAL_BASEURL}`
      : `${process.env.REACT_APP_PROD_BASEURL}`,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Credentials": true,
  },
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response.status === 401) {
      renderErrorMessage(error.response.data.message).then(() => {
        Cookies.remove("jwt");
        window.location.reload();
      });
    } else if (error.response.status === 503) {
      renderSuccessMessage(error.response.data.message);
      throw new Error(error.response.data.message ?? "Account Created");
    } else {
      renderErrorMessage(error.response.data.message);
      throw new Error(error.response.data.message, {
        cause: error.response.status,
      });
    }

    return Promise.reject(error);
  }
);

export const orgsignup = (data) => {
  return api.post("/super-admin/register-enterprise", data);
};

export const verifyEmail = (id) => {
  return api.get(`/super-admin/verify-email/${id}`);
};
